import { render, staticRenderFns } from "./MessageSearchWrapper.vue?vue&type=template&id=3e760f49&"
import script from "./MessageSearchWrapper.vue?vue&type=script&lang=js&"
export * from "./MessageSearchWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports